import { IconButton } from "web/components"

export default function MobileHeader({ field, onCancel }) {
  return (
    <div className="flex items-center justify-between pb-4 md:hidden">
      <div className="text-lg font-bold">{field.label}</div>
      <IconButton name="x-mark" width="25px" height="25px" onClick={onCancel} />
    </div>
  )
}
